exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "ol.numbered[data-v-499cb440] {\n  margin-left: 1.2em;\n}\nol.numbered > li[data-v-499cb440] {\n  list-style: decimal;\n}", ""]);

// exports
